(function () {
  'use strict';

  /* ========== HEADER STICKY SHADOW ========== */
  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var scroll = window.pageYOffset || document.documentElement.scrollTop;
      if (scroll > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = scroll;
    }, { passive: true });
  }

  /* ========== MOBILE MENU ========== */
  var mobileMenu = document.getElementById('MobileMenu');
  var mobileMenuBody = document.getElementById('MobileMenuBody');
  var mobileMenuData = document.getElementById('MobileMenuData');

  function toggleMobileMenu(open) {
    if (!mobileMenu) return;
    var isOpen = open !== undefined ? open : mobileMenu.getAttribute('aria-hidden') === 'true';
    mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    var toggleBtns = document.querySelectorAll('[data-mobile-menu-toggle]');
    toggleBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { toggleMobileMenu(); });
  });

  if (mobileMenuData && mobileMenuBody) {
    try {
      var data = JSON.parse(mobileMenuData.textContent);
      var html = '';
      data.sections.forEach(function (section) {
        html += '<div class="mobile-menu__section-title">' + section.title + '</div>';
        section.links.forEach(function (item) {
        html += '<div class="mobile-menu__group">';
        html += '<a href="' + item.url + '" class="mobile-menu__link">' + item.title + '</a>';
        if (item.links && item.links.length > 0) {
          item.links.forEach(function (child) {
            html += '<a href="' + child.url + '" class="mobile-menu__sub-link">' + child.title + '</a>';
            if (child.links && child.links.length > 0) {
              child.links.forEach(function (grand) {
                html += '<a href="' + grand.url + '" class="mobile-menu__sub-link" style="padding-left:56px">' + grand.title + '</a>';
              });
            }
          });
        }
        });
      });
      mobileMenuBody.innerHTML = html;
    } catch (e) {
      mobileMenuBody.innerHTML = '<div class="mobile-menu__group"><a href="/" class="mobile-menu__link">Home</a></div>';
    }
  }

  /* ========== SEARCH MODAL ========== */
  var searchModal = document.getElementById('SearchModal');
  function toggleSearch(open) {
    if (!searchModal) return;
    var isOpen = open !== undefined ? open : searchModal.getAttribute('aria-hidden') === 'true';
    searchModal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    if (isOpen) {
      var input = searchModal.querySelector('input[type="text"]');
      if (input) setTimeout(function () { input.focus(); }, 100);
    }
  }
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { toggleSearch(); });
  });

  /* ========== CART DRAWER TOGGLE ========== */
  var cartDrawer = document.getElementById('CartDrawer');
  function toggleCartDrawer(open) {
    if (!cartDrawer) return;
    var isOpen = open !== undefined ? open : cartDrawer.getAttribute('aria-hidden') === 'true';
    cartDrawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleCartDrawer();
    });
  });

  /* ========== ESCAPE KEY ========== */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      toggleMobileMenu(false);
      toggleSearch(false);
      if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') toggleCartDrawer(false);
    }
  });

  /* ========== PRODUCT GALLERY THUMBS ========== */
  var thumbs = document.querySelectorAll('[data-thumb-image]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg) {
        mainImg.src = thumb.getAttribute('data-thumb-image');
        thumbs.forEach(function (t) { t.classList.remove('product-gallery__thumb--active'); });
        thumb.classList.add('product-gallery__thumb--active');
      }
    });
  });

  /* ========== VARIANT SELECTOR ========== */
  var variantSelector = document.querySelector('[data-variant-selector]');
  var variantInput = document.querySelector('[data-variant-input]');
  var variantInputBuyNow = document.querySelector('[data-variant-input-buy-now]');
  var addToCartText = document.querySelector('[data-add-to-cart-text]');
  var addToCartBtn = document.querySelector('[data-add-to-cart]');

  if (variantSelector && variantInput) {
    variantSelector.querySelectorAll('.variant-selector__option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        variantSelector.querySelectorAll('.variant-selector__option').forEach(function (o) {
          o.classList.remove('variant-selector__option--selected');
        });
        opt.classList.add('variant-selector__option--selected');

        var variantId = opt.getAttribute('data-variant-id');
        var available = opt.getAttribute('data-variant-available') === 'true';

        variantInput.value = variantId;
        if (variantInputBuyNow) variantInputBuyNow.value = variantId;
// Update displayed price
var priceWrapper = document.querySelector('.product-info__price');
if (priceWrapper) {
  var variantPrice = opt.getAttribute('data-variant-price');
  var variantCompare = opt.getAttribute('data-variant-compare-price');
  var isOnSale = variantCompare && variantCompare !== variantPrice;

  var priceSpan = priceWrapper.querySelector('.price');
  if (priceSpan) {
    priceSpan.className = 'price' + (isOnSale ? ' price--on-sale' : '');
    var currentEl = priceSpan.querySelector('.price__current');
    var compareEl = priceSpan.querySelector('.price__compare');

    if (currentEl) currentEl.textContent = variantPrice;
    if (isOnSale) {
      if (compareEl) {
        compareEl.textContent = variantCompare;
      } else {
        var newCompare = document.createElement('span');
        newCompare.className = 'price__compare';
        newCompare.textContent = variantCompare;
        priceSpan.appendChild(newCompare);
      }
    } else {
      if (compareEl) compareEl.remove();
    }
  }
}

        if (addToCartBtn && addToCartText) {
          if (available) {
            addToCartBtn.disabled = false;
            addToCartText.textContent = window.theme.strings.addToCart;
          } else {
            addToCartBtn.disabled = true;
            addToCartText.textContent = window.theme.strings.soldOut;
          }
        }
      });
    });
  }

  /* ========== QUANTITY CONTROLS ========== */
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      if (input) { input.value = parseInt(input.value, 10) + 1; }
    });
  });
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      if (input) {
        var val = parseInt(input.value, 10) - 1;
        if (val < 1) val = 1;
        input.value = val;
      }
    });
  });

  /* ========== PRODUCT TABS ========== */
  var tabBtns = document.querySelectorAll('[data-tab-target]');
  var tabPanels = document.querySelectorAll('[data-tab-panel]');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab-target');
      tabBtns.forEach(function (b) { b.classList.remove('product-tabs__tab--active'); });
      tabPanels.forEach(function (p) { p.classList.remove('product-tabs__panel--active'); });
      btn.classList.add('product-tabs__tab--active');
      var panel = document.querySelector('[data-tab-panel="' + target + '"]');
      if (panel) panel.classList.add('product-tabs__panel--active');
    });
  });

  /* ========== TWISTED COUNTDOWN ========== */
  var twistedSection = document.querySelector('[data-launch-date]');
  if (twistedSection) {
    var launchDateStr = twistedSection.getAttribute('data-launch-date');
    var launchDate = new Date(launchDateStr + 'T23:59:59').getTime();
    var daysEl = twistedSection.querySelector('[data-countdown-days]');
    var hoursEl = twistedSection.querySelector('[data-countdown-hours]');
    var minsEl = twistedSection.querySelector('[data-countdown-minutes]');
    var secsEl = twistedSection.querySelector('[data-countdown-seconds]');

    function updateCountdown() {
      var now = new Date().getTime();
      var diff = launchDate - now;
      if (diff < 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        return;
      }
      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((diff % (1000 * 60)) / 1000);
      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ========== REVIEWS CAROUSEL ========== */
  var reviewsTrack = document.querySelector('[data-reviews-track]');
  var reviewsPrev = document.querySelector('[data-reviews-prev]');
  var reviewsNext = document.querySelector('[data-reviews-next]');
  if (reviewsTrack) {
    if (reviewsPrev) {
      reviewsPrev.addEventListener('click', function () {
        reviewsTrack.scrollBy({ left: -400, behavior: 'smooth' });
      });
    }
    if (reviewsNext) {
      reviewsNext.addEventListener('click', function () {
        reviewsTrack.scrollBy({ left: 400, behavior: 'smooth' });
      });
    }
  }

  /* ========== COLLECTION FILTERS TOGGLE (MOBILE) ========== */
  var filterToggle = document.querySelector('[data-collection-filters-toggle]');
  var filtersPanel = document.querySelector('[data-collection-filters]');
  if (filterToggle && filtersPanel) {
    filterToggle.addEventListener('click', function () {
      filtersPanel.classList.toggle('collection-filters--open');
    });
  }

  /* ========== COLLECTION FILTERS AUTO-SUBMIT ========== */
  var filtersForm = document.querySelector('[data-collection-filters-form]');
  if (filtersForm) {
    filtersForm.addEventListener('change', function () {
      filtersForm.submit();
    });
  }

  /* ========== SHARE BUTTON ========== */
  var shareBtn = document.querySelector('[data-share-btn]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = shareBtn.getAttribute('data-url');
      if (navigator.share) {
        navigator.share({ url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          shareBtn.textContent = 'Link Copied';
          setTimeout(function () { shareBtn.textContent = 'Share'; }, 2000);
        });
      }
    });
  }

  /* ========== WISHLIST (localStorage, app-extendable) ========== */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }
  function saveWishlist(list) {
    localStorage.setItem('wishlist', JSON.stringify(list));
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }
  function updateWishlistButtons() {
    var wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      if (wishlist.indexOf(pid) > -1) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var pid = btn.getAttribute('data-product-id');
    var wishlist = getWishlist();
    var idx = wishlist.indexOf(pid);
    if (idx > -1) {
      wishlist.splice(idx, 1);
    } else {
      wishlist.push(pid);
    }
    saveWishlist(wishlist);
    updateWishlistCount();
    updateWishlistButtons();
  });

  /* Expose for cart drawer JS */
  window.toggleCartDrawer = toggleCartDrawer;

  /* Init on load */
  updateWishlistCount();
  updateWishlistButtons();
})();
